import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-align-c header" }, "Projects", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectDetail = _resolveComponent("ProjectDetail")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["light-text", _ctx.$style.projectsContainer])
  }, [
    (!_ctx.project)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.projectList)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
              return (_openBlock(), _createElementBlock("div", {
                key: project.name,
                class: _normalizeClass(_ctx.$style.projectListItem),
                style: _normalizeStyle({ backgroundImage: `url(${project.images[0]})`}),
                onClick: ($event: any) => {_ctx.$router.push({
            name: 'ProjectDetail',
            params: { projectName: _ctx.formatNameForNavigate(project.name) }
          });}
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex column", _ctx.$style.projectLIOverlay])
                }, [
                  _createElementVNode("h1", {
                    class: _normalizeClass(_ctx.$style.projectLITitle)
                  }, _toDisplayString(project.name), 3),
                  _createElementVNode("div", {
                    class: _normalizeClass(["padded-container-half flex", _ctx.$style.projectSkillContainer])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.tech, (skill) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: skill.name
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["size-2andhalfem", 'devicon-' + skill])
                        }, null, 2)
                      ]))
                    }), 128))
                  ], 2)
                ], 2)
              ], 14, _hoisted_3))
            }), 128))
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_ProjectDetail, { project: _ctx.project }, null, 8, ["project"])
        ]))
  ], 2))
}